import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "p-0 flex justify-content-between" }
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Show", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 mt-2" }, [
  /*#__PURE__*/_createElementVNode("i", null, "No posts yet.")
], -1)

import { useMutation } from '@vue/apollo-composable';
import PostListItem from "@/components/post/PostListItem.vue";
import PostListItemBrief from "@/components/post/PostListItemBrief.vue";
import gql from 'graphql-tag';
import { ref, watch } from 'vue';
import { Post } from '@/models/post';


export default /*#__PURE__*/_defineComponent({
  props: {
    posts: null,
    brief: { type: Boolean }
  },
  emits: ["on-refresh", "on-post-nb-change"],
  setup(__props: any, { emit }) {





const selectedPostNbOptions = ref(localStorage.getItem("postNbOption") || '25');
const postNbOptions = ref([
  { name: '25', code: '25' },
  { name: '50', code: '50' },
  { name: '100', code: '100' },
  { name: '250', code: '250' }
]);

watch(selectedPostNbOptions, value => {
  localStorage.setItem("postNbOption", value)
  emit("on-post-nb-change", value);
})

const mutation = gql`
  mutation DeletePost($uuid: uuid!) {
    delete_comment(where: { post_uuid: { _eq: $uuid } }) {
      affected_rows
    }
    delete_post_tag(where: { post_uuid: { _eq: $uuid } }) {
      affected_rows
    }
    delete_bookmark(where: { post_uuid: { _eq: $uuid } }) {
      affected_rows
    }
    delete_post_by_pk(uuid: $uuid) {
      uuid
    }
  }
`;

const { mutate, onDone } = useMutation(mutation);

onDone(() => emit("on-refresh"));

const deletePost = (uuid: string) => {
  mutate({ uuid });
};

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataView = _resolveComponent("DataView")!

  return (_openBlock(), _createBlock(_component_DataView, {
    value: __props.posts,
    layout: 'list',
    class: "data-view"
  }, _createSlots({
    list: _withCtx((slotProps) => [
      (__props.brief)
        ? (_openBlock(), _createBlock(PostListItemBrief, {
            key: 0,
            post: slotProps.data
          }, null, 8, ["post"]))
        : (_openBlock(), _createBlock(PostListItem, {
            key: 1,
            post: slotProps.data,
            onDeleteClick: _cache[2] || (_cache[2] = ($event: any) => (deletePost($event)))
          }, null, 8, ["post"]))
    ]),
    empty: _withCtx(() => [
      _hoisted_4
    ]),
    _: 2
  }, [
    (!__props.brief)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_Dropdown, {
                  modelValue: selectedPostNbOptions.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPostNbOptions).value = $event)),
                  options: postNbOptions.value,
                  optionLabel: "name",
                  optionValue: "code"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createVNode(_component_Button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('on-refresh'))),
                label: "Refresh",
                icon: "pi pi-refresh",
                class: "p-button-sm p-button-outlined p-button-secondary"
              })
            ])
          ])
        }
      : undefined
  ]), 1032, ["value"]))
}
}

})